import { Component, Vue } from 'vue-facing-decorator';
import { OfficeBuilding, GoldMedal, Ticket, User, ChatLineRound, Memo, Collection } from '@element-plus/icons-vue';
import ApiService from '@/services/ApiService';

@Component(
{
    components:
    {
        OfficeBuilding,
        GoldMedal,
        Ticket,
        User,
        ChatLineRound,
        Collection,
        Memo
    },
})

export default class Stats extends Vue 
{
    private isLoading : boolean = true;
    private statsModel : StatsModel = {} as StatsModel;

    public async mounted()
    {
        await this.loadStats();
    }

    private async loadStats()
    {
        this.isLoading = true;
        this.statsModel = await ApiService.getStats();
        this.isLoading = false;
    }
}

